import { render, staticRenderFns } from "./legengMap.vue?vue&type=template&id=4c552f64"
import script from "./legengMap.vue?vue&type=script&lang=js"
export * from "./legengMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports